import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Config } from '@/config';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  modifyModalRecoil,
  addressModalRecoil,
  facilitiesAddModalRecoil,
  facilitiesSearchModalRecoil,
} from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import ModalType1 from '@/modal/ModalType1';
import { FacilityApi } from '@/sdk/FacilityApi';
import { UploadApi } from '@/sdk/UploadApi';
import {
  CreateFacilityStep2Dto,
  FacilityControllerGetFacilityDuplicateParams,
  FileUploadDto,
  FacilityManagerDto,
  FacilityControllerGetFacilitiesParams,
  GetFacilitiesDtoRx,
} from '@/sdk/data-contracts';
import SearchBtn from '@/component/SearchBtn';
import { facilitiesListRecoil } from '@/atom/FacilitiesAtom';
import { deviceAddFacilitiesRecoil } from '@/atom/DeviceAtom';

interface FacilitiesSearchModalProps {
  onFacilitiesSelect: (facilities: GetFacilitiesDtoRx) => void;
}

const FacilitiesSearchModal = ({
  onFacilitiesSelect,
}: FacilitiesSearchModalProps) => {
  const facilityApi = new FacilityApi({ baseURL: Config.API_URL });
  const navigate = useNavigate();

  const setErrorModalText = useSetRecoilState(errorModalTextRecoil);
  const setCompleteModalState = useSetRecoilState(completeModalRecoil);
  const [facilitiesSearchModalState, setFacilitiesSearchModalState] =
    useRecoilState(facilitiesSearchModalRecoil);
  const [facilitiesListState, setFacilitiesListState] =
    useRecoilState(facilitiesListRecoil);
  const [deviceAddFacilitiesState, setDeviceAddFacilitiesState] =
    useRecoilState(deviceAddFacilitiesRecoil);

  const [name, setName] = useState<string>('');
  const [sortBy, setSortBy] = useState<string>('createdAt');
  const [order, setOrder] = useState<string>('desc');

  const filterFacilitiesList = async () => {
    const dto: FacilityControllerGetFacilitiesParams = {
      name,
      sortBy,
      order,
    };
    try {
      const { data } = await facilityApi.facilityControllerGetFacilities(dto, {
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      console.log(data);
      if (data.results) setFacilitiesListState(data.results);
    } catch (err: any) {}
  };

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    filterFacilitiesList();
  };

  useEffect(() => {
    filterFacilitiesList();
  }, []);

  return (
    <>
      <ModalType1 width={420}>
        <div className="title-box flex aic jcsb">
          <h1>시설물 검색</h1>
          <button
            className="x-btn img-box"
            onClick={() => setFacilitiesSearchModalState(false)}
          >
            <img src="/img/ico_x_444.svg" alt="" />
          </button>
        </div>
        <div className="cnt-area flex fdc">
          <div className="cnt-wrap flex fdc">
            <div className="cnt-box flex fdc">
              <form onSubmit={handleSearch}>
                <div className="search-box flex">
                  <IS.TextInputType1
                    style={{ width: 330 }}
                    type="text"
                    placeholder="시설물명"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  <SearchBtn />
                </div>
              </form>
              <CS.TableType1>
                <table>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>시설물명</th>
                    </tr>
                  </thead>
                  <tbody>
                    {facilitiesListState.map((list, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td
                          className="button-text"
                          onClick={() => {
                            onFacilitiesSelect(list);
                            setDeviceAddFacilitiesState(list);
                            setFacilitiesSearchModalState(false);
                          }}
                        >
                          {list.name}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </CS.TableType1>
            </div>
          </div>
          <div className="btn-wrap">
            <BS.Btn2Type3
              type="button"
              onClick={() => setFacilitiesSearchModalState(false)}
            >
              닫기
            </BS.Btn2Type3>
          </div>
        </div>
      </ModalType1>
    </>
  );
};

export default FacilitiesSearchModal;
